module.exports = __webpack_public_path__ + "static/img/内镜报告@3x.ccacaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/内镜报告@3x.png
// module id = 785
// module chunks = 382